import textStyles from '../../foundations/textStyles'

export default {
    baseStyle: {
        container: {
            ...textStyles['Regular Medium']
        }
    },
    variants: {
        orderHistory: () => ({
            container: {
                direction: 'column',
                textAlign: 'right',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                spacing: 1
            }
        }),
        cart: () => ({
            container: {
                direction: 'column',
                textAlign: 'right',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                spacing: 1
            }
        }),
        // AddToCartModal
        miniCart: () => ({
            container: {
                direction: 'column',
                spacing: 1
            }
        }),
        pdp: () => ({
            container: {
                flexWrap: 'wrap',
                columnGap: 2,
                rowGap: 1,
                textAlign: 'right',
                justifyContent: 'flex-end',
                alignItems: 'flex-end'
            }
        }),
        order: {
            container: {
                direction: 'row',
                textAlign: 'right',
                justifyContent: 'flex-end',
                alignItems: 'center',
                paddingTop: 2,
                paddingBottom: 3,
                spacing: 4
            }
        },
        tile: () => ({
            container: {
                direction: 'row-reverse',
                justifyContent: 'start',
                gap: 1
            }
        }),
        productTile: {
            container: {
                direction: 'row-reverse',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                gap: {base: 1, md: 1.5}
            }
        }
    }
}
